import React, { useState } from 'react';
import { Lock, User } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '../../api-config';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe por defecto

    try {
      // Realiza una solicitud POST al endpoint /auth/token
      const response = await fetch(`${API_URL}/auth/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          username,
          password,
        }),
      });

      if (!response.ok) {
        // Si la respuesta no es exitosa, muestra un mensaje de error
        const errorData = await response.json();
        setError(errorData.detail || 'Error desconocido');
        return;
      }

      // Extrae el token JWT de la respuesta
      const data = await response.json();
      const token = data.access_token;

      // Almacena el token en localStorage o sessionStorage
      localStorage.setItem('token', token);

      // Redirige al usuario a la página principal o a la página protegida
      navigate('/search');
    } catch (err) {
      // Maneja errores de red u otros problemas
      setError('Error al conectar con el servidor.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center">
      <div className="text-6xl font-medium mb-8 text-center">
        <span className="text-purple-400">I</span>
        <span className="text-purple-300">n</span>
        <span className="text-purple-200">v</span>
        <span className="text-purple-300">i</span>
        <span className="text-purple-400">s</span>
        <span className="text-purple-300">i</span>
        <span className="text-purple-200">o</span>
        <span className="text-purple-300">n</span>
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form className="w-full max-w-md" onSubmit={handleLogin}>
        <div className="relative mb-4">
          <div className="flex items-center border border-purple-400 rounded-full px-6 py-3 hover:shadow-lg hover:shadow-purple-500/20 focus-within:shadow-lg focus-within:shadow-purple-500/20 bg-slate-800">
            <User className="w-5 h-5 text-purple-400 mr-3" />
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Nombre de usuario"
              className="w-full outline-none bg-transparent text-white placeholder-purple-300"
            />
          </div>
        </div>

        <div className="relative mb-6">
          <div className="flex items-center border border-purple-400 rounded-full px-6 py-3 hover:shadow-lg hover:shadow-purple-500/20 focus-within:shadow-lg focus-within:shadow-purple-500/20 bg-slate-800">
            <Lock className="w-5 h-5 text-purple-400 mr-3" />
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Contraseña"
              className="w-full outline-none bg-transparent text-white placeholder-purple-300"
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full px-6 py-3 rounded-full bg-purple-600 hover:bg-purple-700 text-white transition-all duration-300"
        >
          Iniciar sesión
        </button>
      </form>
    </div>
  );
};

export default Login;